import { dataSource } from '@/data';
import type { BuildDetalhe, StatusBuild } from '@/data/types';
import { emitir } from '@/lib/eventos';

/**
 * Executa a troca de status de uma versão e propaga o resultado: devolve o
 * detalhe novo para quem chamou e avisa o barramento (feed/fila atualizam).
 */
export async function aplicarStatus(
  build: Pick<BuildDetalhe, 'versao' | 'produto'>,
  status: StatusBuild,
  motivo: string | null,
): Promise<BuildDetalhe> {
  const detalhe = await dataSource.alterarStatus(build.versao, status, motivo, build.produto);
  emitir({ tipo: 'build', build: detalhe });
  return detalhe;
}
